module.exports = __webpack_public_path__ + "img/list_3_zh.b30ea684.png";